import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SEOContentBlock } from "@/components/seo/SEOContentBlock";
import { seoCopy } from "@/content/seoCopy";
import { Card, CardContent } from "@/components/ui/card";
import { CalendarDays } from "lucide-react";
import { BLOG_POSTS } from "@/content/blogPosts";

const Blog = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Blog | Son's Guadalupe — River News, Tips & Updates"
        description="Stay up to date with Son's Guadalupe. River conditions, seasonal tips, property news, and ideas for your next Guadalupe River getaway in New Braunfels, TX."
        canonical="/blog"
      />
      <Header />
      <main className="pt-24 pb-16">
        <section className="section-padding bg-background">
          <div className="container-narrow mx-auto">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4 text-center">
              Guadalupe River Tips & Guides
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto text-center mb-12">
              Tips, stories, and inspiration for your next river adventure.
            </p>

            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {BLOG_POSTS.map((post) => (
                <Link key={post.slug} to={`/blog/${post.slug}`} className="group">
                  <Card className="overflow-hidden h-full border-0 shadow-soft hover:shadow-elevated transition-shadow duration-300">
                    <div className="aspect-video overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <CardContent className="p-6">
                      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                        <CalendarDays className="w-4 h-4" />
                        {post.date}
                      </div>
                      <h2 className="font-heading text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {post.title}
                      </h2>
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {post.excerpt}
                      </p>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <SEOContentBlock {...seoCopy.blog} />
      <Footer />
    </div>
  );
};

export default Blog;
